import { css } from '@mds/core';

export const layoutResponsiveCSS = css`
	@supports (--foo: 'mds') {

		/* 	###################################################################### */
		/**	Properties for the responsive layout spacing */
		@media not all and (min-width: 576px) {
			:host {
				--display: block;
				--pad-responsive: var(--mds-spacing-4);
				--pad-responsive-viewport: var(--mds-spacing-4);
				--pad-responsive-layout: var(--mds-spacing-4);
			}
		}
		@media (min-width: 576px) {
			:host {
				--pad-responsive: var(--mds-spacing-4);
				--pad-responsive-viewport: var(--mds-spacing-6);
				--pad-responsive-layout: var(--mds-spacing-6);
			}
		}
		@media (min-width: 768px) {
			:host {
				--pad-responsive: var(--mds-spacing-6);
				--pad-responsive-viewport: var(--mds-spacing-7);
				--pad-responsive-layout: var(--mds-spacing-8);
			}
		}
		@media (min-width: 992px) {
			:host {
				--pad-responsive-viewport: 10%;
				--pad-responsive-layout: var(--mds-spacing-10);
			}
		}
		@media (min-width: 1200px) {
			:host{
				--pad-responsive: var(--mds-spacing-8);
				--pad-responsive-viewport: 10%;
			}
		}
		/* breakpoint based on max layout container width (--mds-spacing-layout-max) */
		@media (min-width: 1910px) {
			:host {
				--pad-responsive-viewport: calc((var(--mds-spacing-layout-max) - var(--mds-spacing-layout-content-max)) / 2);
			}
		}
	}
`;
